interface SchemaOrgProps {
  schema: Record<string, unknown>;
}

export function SchemaOrg({ schema }: SchemaOrgProps) {
  const jsonLd = JSON.stringify({
    '@context': 'https://schema.org',
    ...schema,
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: jsonLd }}
    />
  );
}